import { atom, getDefaultStore } from 'jotai'
import useAbortController from '../../../../../hooks/useAbortController'

const cloneRequestControllerAtom = atom(new AbortController())

const useCloneRequestController = () => {
  const result = useAbortController(cloneRequestControllerAtom)
  const getController = () => getDefaultStore().get(cloneRequestControllerAtom)
  return { ...result, getController }
}

export default useCloneRequestController
